import { connect } from 'react-redux';
import AppCaseSearch from 'components/app-case/app-case-search';
import { setKeyword as setKeywordAction } from 'actions/case-keyword';

const mapStateToProps = state => {
  const { total } = state.searchList;
  return {
    userInfo: state.userInfo,
    total,
    ...state.caseKeyword, // keywordId, keyword, relWords, hotWords, cover
  };
};

const mapDispatchToProps = dispatch => ({
  setKeyword: keyword => {
    dispatch(setKeywordAction(keyword));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppCaseSearch);
